import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { EmailFileModel } from "src/app/Models";
@Injectable({
  providedIn: "root",
})
export class GraphService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  sendEmail(mailOptions: EmailFileModel
  ): Observable<any> {
    const url = `${this.apiUrl}Graph/emailFile`;
    return this.http.post<any>(url, mailOptions);
  }

  getPreviewUrl(fileId: string): Observable<any> {
    const url = `${this.apiUrl}Graph/getFilePreviewLink/${fileId}`.toString();
    return this.http.get<any>(url);
  }

  getDownloadUrl(fileId: string): Observable<any> {
    const url = `${this.apiUrl}Graph/getFileDownloadLink/${fileId}`.toString();
    return this.http.get<any>(url);
  }

  getDownloadUrl1(fileId: string, driveId: string): Observable<any> {
    const url = `${this.apiUrl}Graph/GetDownloadLinkByDriveId?fileId=${fileId}&driveId=${driveId}`
    return this.http.get<any>(url);
  }

  getFileContent1(id: string, name: string): Observable<any> {
    const url = `${this.apiUrl}Graph/getFileContent1`.toString();
    return this.http.post(
      url,
      { fileId: id, fileName: name, driveId: "b!zi8A-wK5a06GfaPLpbn7G7B6mmearCdDreB_O544hnWxwCtKAdOCRJvFsUJUDXgq" },
      { responseType: "blob" }
    );
  }
}
